import { BehaviorSubject } from 'rxjs';

// Human-readable failure reason (e.g. "Declined") from the last embedded
// Tap2Pay attempt on this CDS, surfaced on the payment error screen. The
// ORDER_PAYMENT_PROCESSED event has no field to carry it, so for the embedded
// flow we keep it here. Cleared at the start of each new payment.
export const paymentErrorReasonSubject = new BehaviorSubject<string | undefined>(
  undefined,
);
